"use strict";

require("core-js/modules/es6.array.reduce");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

var hasProps = function hasProps(jsx) {
  return Object.prototype.hasOwnProperty.call(jsx, 'props');
};

var reduceJsxToString = function reduceJsxToString(previous, current) {
  return previous + innerText(current);
};

var innerText = function innerText(jsx) {
  if (jsx === null || typeof jsx === 'boolean' || typeof jsx === 'undefined') {
    return '';
  }

  if (typeof jsx === 'number') {
    return jsx.toString();
  }

  if (typeof jsx === 'string') {
    return jsx;
  }

  if (Array.isArray(jsx)) {
    return jsx.reduce(reduceJsxToString, '');
  }

  if (hasProps(jsx) && Object.prototype.hasOwnProperty.call(jsx.props, 'children')) {
    return innerText(jsx.props.children);
  }

  return '';
};

innerText["default"] = innerText;
module.exports = innerText;